module.exports = __webpack_public_path__ + "img/IT0000078260432.9e1879bf.png";